/// <reference path="../../../../../typings/index.d.ts" />
module Meevo.Plugins.AddOnGroup {
    'use strict';

    enum ToggleEnum {
        selected,
        deselected
    }

    interface IServiceCategory {
        displayName: string;
        id: number
    }

    interface IService {
        displayName: string,
        id: number,
        selected?: boolean
    }

    interface IAddOnGroupMoverToolController {
        // directive attributes
        isReadonly?: boolean;
        ngModel: angular.INgModelController;
        criteria: Object;
        serviceCategoriesData: Array<IServiceCategory>;
        servicesData: Array<IService>;
        excludeList: Array<IService>;
        required: boolean;
        changed(): void;
        serviceCategories: Array<IServiceCategory>;
        services: Array<IService>;

        servicesSelection: Array<IService>;
        selectedServicesSelection: Array<IService>;
        fetching: boolean;
        selectedCategoryId: Guid;
        isServicesChangedManually: boolean;
        init(): void;
        select(): void;
        deselect(): void;
        toggleAll(toggle: ToggleEnum): void;
        checkServices(toggle: ToggleEnum): boolean;
        getSelectedServices(): Array<IService>;
        prePopulate(): void;
        setModelValue(): void;
        categoryChanged(): void;
        getServicesByCategory(): ng.IPromise<any>;
    }

    export class AddOnGroupMoverToolController implements IAddOnGroupMoverToolController {
        isReadonly: boolean;
        ngModel: angular.INgModelController;
        criteria: Object;
        serviceCategoriesData: Array<IServiceCategory>;
        servicesData: Array<IService>;
        excludeList: Array<IService>;
        required: boolean;
        serviceCategories: Array<IServiceCategory> = [];
        services: Array<IService> = [];

        servicesSelection: Array<IService> = [];
        selectedServicesSelection: Array<IService> = [];
        fetching: boolean = true;
        selectedCategoryId: Guid = null;
        isServicesChangedManually: boolean = false;

        static $inject = [
            '$scope',
            '$q',
            '$timeout',
            'meevo.components.common.DataService',
            'meevo.components.busy.BusyService'
        ];

        constructor(
            protected $scope: angular.IScope,
            protected $q: ng.IQService,
            protected $timeout: ng.ITimeoutService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService
        ) {}

        changed(): void {
            if (angular.isFunction(this.changed)) {
                this.changed();
            }
        }
        /**
         * Function to be called when directive is initialized
         */
        init(): void {
            this.$timeout(() => {
                if (!angular.isArray(this.ngModel.$viewValue)) {
                    this.ngModel.$setViewValue([]);
                }

                this.prePopulate();
            });

            this.$scope.$watch(() => this.ngModel.$viewValue, (newValue, oldValue) => {
                if (angular.isDefined(newValue) && !angular.equals(newValue, oldValue) && !this.isServicesChangedManually) {
                    this.prePopulate();
                }

                this.isServicesChangedManually = false;
            }, true);

            this.$scope.$watch(() => this.serviceCategoriesData, (newValue, oldValue) => {
                this.serviceCategories = angular.copy(newValue);
            }, true);

            this.$scope.$watch(() => this.servicesData, (newValue, oldValue) => {
                this.services = angular.copy(newValue);
                if (this.ngModel.$viewValue) {
                    this.prePopulate();
                }
            }, true);
        }

        /**
         * Select service
         */
        select(): void {
            this.servicesSelection.forEach((service: IService) => {service.selected = true;});
            this.setModelValue();
            this.changed();
        }

        /**
         * Deselect service
         */
        deselect(): void {
            this.selectedServicesSelection.forEach((service: IService) => { service.selected = false;});
            this.setModelValue();
            this.changed();
        }

        /**
         * Select or deselect all services in one time
         * @param {ToggleEnum} toggle
         */
        toggleAll(toggle: ToggleEnum): void {
            let selected = toggle === ToggleEnum.selected,
                excludeList = this.excludeList || [];

            this.services.forEach((service: IService) => {
                if (!excludeList.some((excludedService: IService) => excludedService.id === service.id)) {
                    service.selected = selected;
                }
            });

            this.setModelValue();
            this.changed();
        }

        /**
         * Check if all services are selected
         * @param {ToggleEnum} toggle
         * @returns {boolean}
         */
        checkServices(toggle: ToggleEnum): boolean {
            let selected = toggle === ToggleEnum.selected;

            return !!this.services && this.services.every((service: IService) => service.selected === selected);
        }

        /**
         * Get selected services
         * @returns {Array} IService
         */
        getSelectedServices(): Array<IService> {
            return !!this.services && this.services.filter((service: IService) => service.selected);
        }

        /**
         * Pre populate selected services based on ngModel value
         */
        prePopulate(): void {
            if (!this.services) {
                return;
            }
            this.services.forEach((service: IService) => {
                service.selected = false;
            });

            this.ngModel.$viewValue.forEach((selectedService: IService) => {
                selectedService.selected = true;

                for (var i = 0; i < this.services.length; i++) {
                    let service: IService = this.services[i];

                    if (selectedService.id === service.id) {
                        let index = this.services.indexOf(service);

                        this.services.splice(index, 1);
                        break;
                    }
                }

                this.services.push(selectedService);
            });
        }

        /**
         * Set model value
         */
        setModelValue(): void {
            this.isServicesChangedManually = true;
            this.ngModel.$setViewValue(this.getSelectedServices());
        }

        /**
         * User selects another category through select box
         */
        categoryChanged(): void {
            this.busyService.start();
            this.getServicesByCategory()
                .finally(() => {
                    this.busyService.stop();
                });
        }

        /**
         * Get services
         * @returns {ng.IPromise<any>} promise
         */
        getServicesByCategory(): ng.IPromise<any> {
            let data: Object = {
                criteria: _.extend(this.criteria, {
                    serviceCategoryId: this.selectedCategoryId
                }),
                itemsPerPage: 10000
            };

            return this.dataService.getListPaged('Service', data)
                .then((services: Array<IService> | any) => {
                    this.services = services;
                    this.prePopulate();
                });
        }

        /**
         * 
         * @param {Array<IService>} excludeList
         */
        excludeFilter(excludeList: Array<IService>) {
            return (service: IService) => {
                return !!service && service.selected === false && !excludeList.some((item: IService) => item.id === service.id);
            }
        }

        get toggleEnum(): any {
            return ToggleEnum;
        }
    }
}